module.exports = " <div> <layout-header></layout-header> <div class=container-fluid> <div class=row> <div id=sidebar class=\"sidebar sidebar-left col-sm-3 col-md-2 hidden-xs\" style=position:fixed> <layout-sidebar></layout-sidebar> </div> <div class=main ng-class=\"{'col-sm-12 col-md-12': !menuLateral, 'col-sm-9 col-sm-offset-3 col-md-10 col-md-offset-2': menuLateral}\"> <ui-view></ui-view> </div> </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/modules/layout/layout-template.html
// module id = 270
// module chunks = 1